import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'projects/packcert-web/src/environments/environment';

@Injectable()
export class AdminService {

    constructor(private readonly _http: HttpClient, private readonly _translate: TranslateService){}

    //MANTENIMIENTO PAISES
    public getPaises(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Pais/GetAllConFiltro', filters);
    }

    public getPais(paisId) {
        return this._http.get<any>(environment.apiEndpoint + '/Pais/GetById/?paisid=' + paisId);
    }

    public createPais(pais) {
        return this._http.post<any>(environment.apiEndpoint + '/Pais', pais );
    }

    public createPaisIdioma(pais) {
        return this._http.post<any>(environment.apiEndpoint + '/Pais/InsertPaisIdioma', pais);
    }

    public deletePais(paisId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Pais/?id=' + paisId);
    }

    public deletePaisIdioma(paisId, idiomaId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Pais/DeletePaisIdioma?paisId=' + paisId + '&idiomaId=' + idiomaId);
    }

    public updatePais(pais) {
        return this._http.put<any>(environment.apiEndpoint + '/Pais', pais);
    }

    // PROVINCIAS
    public getProvinciasByPaisId(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Provincia/GetAllConFiltro', filters);
    }

    public CreateProvincia(provincia) {
        return this._http.post<any>(environment.apiEndpoint + '/Provincia', provincia );
    }

    public updateProvincia(provincia) {
        return this._http.put<any>(environment.apiEndpoint + '/Provincia', provincia);
    }

    public deleteProvincia(provinciaId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Provincia/?id=' + provinciaId);
    }

    // MANTENIMIENTO MUNICIPIOS
    public getMunicipios(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Municipio/GetAllConFiltro', filters);
    }

    public getMunicipio(municipioId) {
        return this._http.get<any>(environment.apiEndpoint + '/Municipio/GetById/?municipioId=' + municipioId);
    }

    public getMunicipiosByProvinciaId(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Municipio/GetAllConFiltro', filters);
    }

    public createMunicipio(municipio) {
        return this._http.post<any>(environment.apiEndpoint + '/Municipio', municipio);
    }

    public updateMunicipio(municipio) {
        return this._http.put<any>(environment.apiEndpoint + '/Municipio', municipio);
    }

    public deleteMunicipio(municipioId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Municipio/?id=' + municipioId);
    }

    // GESTION LICENCIAS
    public getLicencias(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/LicenciaSw/GetAllConFiltro', filters);
    }

    public getLicencia(licenciaSwId) {
        return this._http.get<any>(environment.apiEndpoint + '/LicenciaSw/GetById/?licenciaSwId=' + licenciaSwId);
    }

    public getVersionesSW() {
        return this._http.get<any>(environment.apiEndpoint + '/VersionSW/GetAll/?tipoSwId=1');
    }

    public createLicencia(licencia) {
        return this._http.post<any>(environment.apiEndpoint + '/LicenciaSw', licencia);
    }

    public updateLicencia(licencia) {
        return this._http.put<any>(environment.apiEndpoint + '/LicenciaSw', licencia);
    }

    public deleteLicencia(licenciaId) {
        return this._http.delete<any>(environment.apiEndpoint + '/LicenciaSw/?id=' + licenciaId);
    }

    public getHistorialActivacionesLicencia(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/LicenciaSw/GetHistModActivacionesLicencia', filters);
    }

    public getLicenciaParams(licenciaId) {
        return this._http.get<any>(environment.apiEndpoint + '/LicenciaParametrizacion/GetAll?licenciaSwId=' + licenciaId);
    }

    public createLicenciaParam(licencia) {
        return this._http.post<any>(environment.apiEndpoint + '/LicenciaParametrizacion/InsertLicenciaParametrizacion', licencia);
    }

    public deleteLicenciaParam(licenciaId, almacenId, denominacionId, paisId) {
        return this._http.delete<any>(environment.apiEndpoint + '/LicenciaParametrizacion/?licenciaSwId='
            + licenciaId + '&almacenId=' + almacenId + '&denominacionId=' + denominacionId + '&paisId=' + paisId);
    }

    public desactivarLicencia(licencia) {
        return this._http.post<any>(environment.apiEndpoint + '/LicenciaSw/DesactivarLicenciaSwYGenerarDuplicado', licencia);
    }

    // ALMACENES - ETIQUETADOR
    public getAlmacenesByEtiquetador(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Almacen/GetAllConFiltro', filters);
    }

    // GRUPOS - ETIQUETA
    public getGruposEtiquetaDenominacion(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/GrupoEtiqueta/GetAllConFiltro', filters);
    }

    public getGruposEtiqueta(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/GrupoEtiqueta/GetAllConFiltro', filters);
    }

    public updateGrupoEtiquetasDenominacion(grupoEtiquetas) {
        return this._http.put<any>(environment.apiEndpoint  + '/GrupoEtiqueta/UpdateGrupoEtiquetaLicenciaParametrizacion', grupoEtiquetas);
    }

    public updateCertificadosGestionLicencias(filters) {
        return this._http.put<any>(environment.apiEndpoint  + '/LicenciaParametrizacion/UpdateLicenciaParametrizacion', filters);
    }

    public deleteGrupoEtiquetasDenominacion(grupoEtiquetasDenominacion) {
        return this._http.delete<any>(environment.apiEndpoint + '/GrupoEtiqueta/DeleteGrupoEtiquetaLicenciaParametrizacion/?grupoEtiquetaId=' + grupoEtiquetasDenominacion.grupoEtiquetaId +
            '&licenciaSwId=' + grupoEtiquetasDenominacion.licenciaSwId + '&almacenId=' + grupoEtiquetasDenominacion.almacenId + '&denominacionId=' + grupoEtiquetasDenominacion.denominacionId);
    }

    public updateGrupoEtiquetasMarca(grupoEtiquetas) {
        return this._http.put<any>(environment.apiEndpoint  + '/GrupoEtiqueta/UpdateGrupoEtiquetaLicenciaParametrizacionMarca', grupoEtiquetas);
    }

    public deleteGrupoEtiquetasMarca(grupoEtiquetasMarca) {
        return this._http.delete<any>(environment.apiEndpoint + '/GrupoEtiqueta/DeleteGrupoEtiquetaLicenciaParametrizacionMarca/?grupoEtiquetaId=' + grupoEtiquetasMarca.grupoEtiquetaId +
        '&licenciaSwId=' + grupoEtiquetasMarca.licenciaSwId + '&almacenId=' + grupoEtiquetasMarca.almacenId + '&denominacionId=' + grupoEtiquetasMarca.denominacionId + '&marcaId=' + grupoEtiquetasMarca.marcaId);
    }

    // DENOMINACIONES
    public getDenominaciones(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Denominacion/GetAllConFiltro', filters);
    }

    // ENTIDADES CONTROL
    public getEntidadesControl(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/EntidadControl/GetAllConFiltro', filters);
    }

    public createEntidadControl(entidadControl) {
        return this._http.post<any>(environment.apiEndpoint + '/EntidadControl', entidadControl);
    }

    public updateEntidadControl(entidadControl) {
        return this._http.put<any>(environment.apiEndpoint + '/EntidadControl', entidadControl);
    }

    public updateBlockchainSettingsEC(entidadControl) {
        return this._http.put<any>(environment.apiEndpoint + '/EntidadControl/UpdateBlockchainSettings', entidadControl);
    }

    public deleteEntidadControl(entidadControlId) {
        return this._http.delete<any>(environment.apiEndpoint + '/EntidadControl/?entidadControlId=' + entidadControlId);
    }

    // AUDITORES
    public getAuditores(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Auditor/GetAllConFiltro', filters);
    }

    // INTEGRADORES
    public getIntegradores(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Integrador/GetAllConFiltro', filters);
    }

    // ENTIDAD - PAIS -DENOMINACION
    public getEntidadesControlPaisDenominacion(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/EntidadControl/GetAllEntidadControlPaisDenominacionConFiltro', filters);
    }

    public createEntidadControlPaisDenominacion(entidadControlPaisDenominacion) {
        return this._http.post<any>(environment.apiEndpoint + '/EntidadControl/InsertEntidadControlPaisDenominacion',
            entidadControlPaisDenominacion );
    }

    public updateEntidadControlPaisDenominacion(entidadControlPaisDenominacion) {
        return this._http.put<any>(environment.apiEndpoint + '/EntidadControl/UpdateEntidadControlPaisDenominacion',
            entidadControlPaisDenominacion );
    }

    public deleteEntidadControlPaisDenominacion(entidadControlId, paisId, denominacionId) {
        return this._http.delete<any>(environment.apiEndpoint + '/EntidadControl/DeleteEntidadControlPaisDenominacion/?entidadControlId=' +
            entidadControlId + '&paisId=' + paisId + '&denominacionId=' + denominacionId);
    }

    // LOGS
    public getLogs(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Log/GetAllConFiltro', filters);
    }

      public getRoles() {
        return this._http.get<any>(environment.apiEndpoint + '/ApplicationUser/GetAllRoles');
    }

    public getTiposLog() {
        return this._http.get<any>(environment.apiEndpoint + '/Log/GetAllEnumTipoLog');
    }

    // CSV INSERCIÓN LOGS
    public getCsvLogs(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Utilities/GetAllLogsCsvByFiltro', filters);
    }

    public getCsvLogsDetail(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Utilities/GetLogCsvDataByFileName', filters);
    }

    public downloadCsvLog(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Utilities/DownloadLogCsvDataByFileName', filters );
    }

    public getCsvTypes() {
        const types: Array<any> = [];
        let id = 1;

        this._translate.get('csv-import.table.type').subscribe(res => {
            Object.entries(res).forEach(([key, value]) => {
            if (key === 'title') {
                return;
            }

            types.push({ des: value, id: id, titlesKey: key });
            id += 1;
        });
    });

    return types;
    }

    // GESTION DE ROYALTIES
    public getRoyaltiesFee(filters){
      return this._http.post<any>(environment.apiEndpoint + '/Royalty/CalculaFee', filters);
    }

    public getEntidadControlAll() {
      return this._http.get<any>(environment.apiEndpoint + '/EntidadControl/GetAll');
    }

    public getPaisesByEntidadControl(filters){
      return this._http.post<any>(environment.apiEndpoint + '/Pais/GetAllConFiltro', filters);
    }

    public getDenominacionesByPaisEntidadControl(filters){
      return this._http.post<any>(environment.apiEndpoint + '/Denominacion/GetAllConFiltro', filters);
    }

    public getMarcasByPaisEntidadControlDeno(filters){
      return this._http.post<any>(environment.apiEndpoint + '/Marca/GetAllConFiltro', filters);
    }

    public getEtiquetadoresByEntidadControl(filters){
      return this._http.post<any>(environment.apiEndpoint + '/Etiquetador/GetAllConFiltro', filters);
    }

    public getProuctoresByEntidadControl(filters){
      return this._http.post<any>(environment.apiEndpoint + '/Productor/GetAllConFiltro', filters);
    }

    public getReportRoyalty(filters){
      return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepRoyalty', filters);
    }

    // AYUDA
    public getDocHelp(nombreArchivo: string) {
      return this._http.get<any>(environment.apiEndpoint + '/Utilities/GetDocHelp/?nombreArchivo=' + nombreArchivo);
    }

    // REGISTRO ACTIVIDAD
    public getRegistroActividad(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/RegistroActividadWeb/GetAllConFiltro', filters);
    }

    // VERSIONES ETIQUETADO
    public getVersionesEtiquetado(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/VersionSw/GetAllConFiltro', filters);
    }

    public getVersionEtiquetado(versionSwId) {
        return this._http.get<any>(environment.apiEndpoint + '/VersionSw/GetById/?versionSwId=' + versionSwId);
    }

    public createVersionEtiquetado(versionSw) {
        return this._http.post<any>(environment.apiEndpoint + '/VersionSw', versionSw);
    }

    public updateVersionEtiquetado(versionSw) {
        return this._http.put<any>(environment.apiEndpoint + '/VersionSw', versionSw);
    }

    public deleteVersionEtiquetado(versionSwId) {
        return this._http.delete<any>(environment.apiEndpoint + '/VersionSw/?id=' + versionSwId);
    }

    public asociaInstaladorBlob(instalador) {
        return this._http.post<any>(environment.apiEndpoint + '/VersionSw/AsociaInstaladorBlob', instalador);
    }

    public asociaActualizadorBlob(actualizador) {
        return this._http.post<any>(environment.apiEndpoint + '/VersionSw/AsociaActualizadorBlob', actualizador);
    }

    public deleteActualizacionAutomatica(versionSwId, paisId, denominacionId) {
        return this._http.delete<any>(environment.apiEndpoint + '/LicenciaSw/DeleteActualizacionAutomatica/?versionSwId=' + versionSwId + '&paisId=' + paisId + '&denominacionId=' + denominacionId);
    }

    public getNotificaciones(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/NotificacionWeb/GetAllConFiltro', filters);
    }

    public getNotificacionesPendientes(notificationsNumber) {
        return this._http.get<any>(environment.apiEndpoint + '/NotificacionWeb/GetPendienteLectura/?tamPagina=' + notificationsNumber);
    }

    public getNotificacion(notificacionId) {
        return this._http.get<any>(environment.apiEndpoint + '/NotificacionWeb/GetById/?notificacionWebId=' + notificacionId);
    }
    
    public createNotificacion(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/NotificacionWeb', filters);
    }

    public updateNotificacion(filters) {
        return this._http.put<any>(environment.apiEndpoint + '/NotificacionWeb', filters);
    }

    public deleteNotificacion(notificacionId) {
        return this._http.delete<any>(environment.apiEndpoint + '/NotificacionWeb/?notificacionWebId=' + notificacionId);
    }

    public setNotificacionLeida(notificationId) {
        return this._http.post<any>(environment.apiEndpoint + '/NotificacionWeb/SetNotificacionWebLeida/?notificacionWebId=' + notificationId + '&leida=true', null);
    }
}